export default class FormInputEvent extends Event {
	public static NOT_VALID_VALUE_CHANGED = 'FormInputEvent.notValidValueChanged';
	public static VALID_VALUE_CHANGED = 'FormInputEvent.validValueChanged';

	public get key(): string {
		return this.#key;
	}

	public get value(): string {
		return this.#value;
	}

	#key: string;
	#value: string;
	public constructor(type: string, key: string, value: string) {
		super(type, { bubbles: true });
		this.#key = key;
		this.#value = value;
	}
}
